import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { P500UIButtonsModule, P500UIIconsModule } from '@platform500services/p500-ui-kit';
import { ActionButtonDirectiveModule } from '../../directives/action-button/action-button.module';
import { RbacDirectiveModule } from '../../directives/rbac/rbac-directive.module';
import { FieldsModule } from '../fields/fields.module';
import { BaseMetricCardComponent } from './base-metric-card.component';
import { DotSeparatorModule } from '../dot-separator/dot-separator.module';

@NgModule({
  declarations: [BaseMetricCardComponent],
  exports: [BaseMetricCardComponent],
  imports: [
    CommonModule,
    ActionButtonDirectiveModule,
    P500UIButtonsModule,
    P500UIIconsModule,
    FieldsModule,
    RbacDirectiveModule,
    DotSeparatorModule,
  ],
})
export class BaseMetricCardModule {}
